import axios from 'axios'
import store from '../store'
const service = axios.create({
    timeout: 15000 // 请求超时时间
})
import { Message } from 'element-ui'
// respone拦截器
service.interceptors.request.use(
    config => {
        config.headers.token = store.state.loginToken;
        return config
    },
)
service.interceptors.response.use(
    response => {
        const res = response
        if (res.status == 200) {
            return res.data;
        } else {
            Message({
                message: res.ErrMsg,
                type: 'error',
                duration: 3 * 1000
            });
            return Promise.reject('error');
        }
        // return res
    },
    error => {
        Message({
            message: error.message,
            type: 'error',
            duration: 3 * 1000
        })
        return Promise.reject(error);
    }
)

export default service